import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_CALENDAR: GlameraIconDefinition = {
  name: 'calendar',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-calendar-hanger glm-calendar-hanger-left" pathLength="1" d="M8 2v4"></path>
    <path class="glm-calendar-hanger glm-calendar-hanger-right" pathLength="1" d="M16 2v4"></path>
    <rect class="glm-calendar-body" pathLength="1" width="18" height="18" x="3" y="4" rx="2"></rect>
    <path class="glm-calendar-header" d="M3 10h18"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-calendar-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './calendar.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CalendarIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_CALENDAR;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
